export class MediaFile {
  id: string; // mediaId
  sourceType: SourceType;
  sourceId: string; // channelId
  orgUuid: string;
  identityUuid: string;
  userId: string;
  messageId: string;
  name: string;
  uri: string;
  fileKey: string;
  mimeType: string;
  fileType: string;
  fileSize: number;
  createdAt: number;
  metadata: {
    width: number;
    height: number;
    // anything
  };

  constructor(obj?: Partial<MediaFile>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

export enum SourceType {
  teamchat = 'teamchat',
  newsfeed = 'newsfeed',
  email = 'email',
  whatsapp = 'whatsapp',
  supportCenter = 'supportCenter'
}

export interface ReqGetJWT {
  sourceType: SourceType;
  sourceId: string;
  name: string;
  fileType: string;
  size: number;
  metadata?: {
    width: number;
    height: number;
  };
}

export interface ResGetJWT {
  token: string; // jwt
  mediaId: string; // id file like s3Key
  fileKey: string;
  orgUuid: string;
}
